import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Navbar from "./Navbar";
import logoMostakhbal from "../assets/logoMostakhbal.png";

const CLUB_LOGO = logoMostakhbal;
const CLUB_NAME = "مستقبل المرسى العيون";

function TeamBadge({ name, logo, initials }) {
  return (
    <div className="w-11 h-11 sm:w-14 sm:h-14 shrink-0 rounded-full bg-white dark:bg-neutral-800 border-2 border-[#2596be]/30 dark:border-sky-500/40 flex items-center justify-center overflow-hidden shadow-sm">
      {logo === CLUB_LOGO ? (
        <>
          <img
            src="/logoMostakhbal.png"
            alt={name}
            className="w-full h-full object-contain p-1.5 block dark:hidden"
          />
          <img
            src="/logo-cmml.png"
            alt={name}
            className="w-full h-full object-contain p-1.5 hidden dark:block"
          />
        </>
      ) : logo ? (
        <img
          src={logo}
          alt={name}
          className="w-full h-full object-contain p-1.5"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
            e.currentTarget.nextElementSibling.style.display = 'flex';
          }}
        />
      ) : null}
      <span
        style={{ display: logo ? 'none' : 'flex' }}
        className="text-[10px] sm:text-xs font-bold text-[#2596be] dark:text-sky-400"
      >
        {initials}
      </span>
    </div>
  );
}

export default function Matches() {
  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/full-schedule.json')
      .then((res) => res.json())
      .then((data) => {
        setSchedule(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error loading match schedule:', err);
        setLoading(false);
      });
  }, []);

  const allerMatches = schedule.filter((m) => m.matchday <= 15);
  const retourMatches = schedule.filter((m) => m.matchday > 15);

  const renderMatchRow = (match) => {
    const isHome = match.venue === 'home';

    const homeSide = isHome
      ? { name: CLUB_NAME, logo: CLUB_LOGO, initials: "CMML" }
      : { name: match.opponent, logo: match.opponentLogo, initials: match.opponentInitials };

    const awaySide = isHome
      ? { name: match.opponent, logo: match.opponentLogo, initials: match.opponentInitials }
      : { name: CLUB_NAME, logo: CLUB_LOGO, initials: "CMML" };

    return (
      <div
        key={match.matchday}
        className={`flex flex-col gap-3 px-4 py-4 rounded-xl border transition-colors ${
          match.played
            ? "bg-white dark:bg-neutral-900 border-gray-100 dark:border-neutral-800"
            : "bg-neutral-50 dark:bg-neutral-950 border-gray-100 dark:border-neutral-800"
        }`}
      >
        <div className="flex items-center justify-between">
          <span className="text-xs font-bold text-gray-400 dark:text-neutral-500">
            الجولة {match.matchday}
          </span>
          <span
            className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${
              isHome
                ? "bg-[#2596be]/10 text-[#2596be] dark:bg-sky-500/10 dark:text-sky-400"
                : "bg-neutral-200 text-neutral-600 dark:bg-neutral-800 dark:text-neutral-400"
            }`}
          >
            {isHome ? "لقاء بالديار" : "لقاء خارجي"}
          </span>
        </div>

        <div className="flex items-center justify-between gap-2 sm:gap-4">
          <div className="flex flex-col items-center gap-1.5 flex-1 min-w-0">
            <TeamBadge {...homeSide} />
            <span className="text-xs sm:text-sm font-semibold text-neutral-800 dark:text-neutral-200 text-center leading-tight truncate w-full">
              {homeSide.name}
            </span>
          </div>

          <div className="shrink-0 flex flex-col items-center gap-1 px-1">
            {match.played ? (
              <span className="text-base sm:text-lg font-extrabold text-[#2596be] dark:text-sky-400">
                {match.score}
              </span>
            ) : (
              <>
                <span className="text-xs sm:text-sm font-extrabold text-neutral-400 dark:text-neutral-500 bg-neutral-100 dark:bg-neutral-800 px-2.5 py-1 rounded-md">
                  VS
                </span>
                <span className="text-[10px] text-gray-400 dark:text-neutral-500">قريباً</span>
              </>
            )}
          </div>

          <div className="flex flex-col items-center gap-1.5 flex-1 min-w-0">
            <TeamBadge {...awaySide} />
            <span className="text-xs sm:text-sm font-semibold text-neutral-800 dark:text-neutral-200 text-center leading-tight truncate w-full">
              {awaySide.name}
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
    <Navbar />
    <section dir="rtl" className="w-full bg-[#f9f9f9] dark:bg-neutral-950 py-10 font-sans transition-colors duration-300 min-h-screen">
      <div className="max-w-3xl mx-auto px-4 flex flex-col items-center">

        <Link
          to="/"
          className="self-start flex items-center gap-2 text-[#2596be] dark:text-sky-400 font-bold text-sm mb-6 hover:underline"
        >
          <ArrowRight size={18} />
          رجوع
        </Link>

        <h2 className="text-3xl font-medium text-[#2596be] dark:text-sky-400 mb-8">
          برنامج مباريات مستقبل المرسى
        </h2>

        {loading ? (
          <div className="text-center py-10 text-gray-500 dark:text-neutral-400 font-medium">
            جاري تحميل البرنامج...
          </div>
        ) : (
          <div className="w-full flex flex-col gap-8">
            <div>
              <h3 className="text-lg font-bold text-neutral-700 dark:text-neutral-300 mb-3 px-1">
                مرحلة الذهاب
              </h3>
              <div className="flex flex-col gap-2">
                {allerMatches.map(renderMatchRow)}
              </div>
            </div>

            <div>
              <h3 className="text-lg font-bold text-neutral-700 dark:text-neutral-300 mb-3 px-1">
                مرحلة الإياب
              </h3>
              <div className="flex flex-col gap-2">
                {retourMatches.map(renderMatchRow)}
              </div>
            </div>
          </div>
        )}

      </div>
    </section>
    </>
  );
}
